import { VStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import React from 'react';

import { ResposiveLoadingItem } from '../LoadingItem';

export const LoadingTabletTable: React.FC = () => {
  const loadingSize = { length: 6 };

  return (
    <VStack space={Spacing['inline.nano']}>
      {Array.from(loadingSize).map((__, i) => (
        <ResposiveLoadingItem key={`customer-table-skeleton-${i}`} />
      ))}
    </VStack>
  );
};
